import React from 'react';
import Confetti from 'react-confetti';

function ConfettiCannon() {
  const width = window.innerWidth;
  const height = window.innerHeight;

  return (
    <Confetti
      width={width}
      height={height}
      recycle={false}
      numberOfPieces={200}
      gravity={0.2}
      wind={0.05}
      colors={['#ff69b4', '#ffe4e1', '#ffc0cb', '#f08080', '#e6e6fa', '#dda0dd']} // Romantic color palette
    />
  );
}

export default ConfettiCannon;